import { apiFetch } from '../helpers/api-fetch';
import { WorkTask } from '../models/worktask';

export class WorkTaskService {

    static readonly APIUrl = process.env.REACT_APP_API_URL as string + "/api/worktasks"; // API server domain

    // Get all work task from group
    public static async getAllfromGroup(groupId: number) {
        const res = await apiFetch(`${this.APIUrl}/GetTasksFromGroup/${groupId}`, {
            method: 'GET'
        });
        return Promise.resolve(res);
    }

    // Get Work task by id
    public static async getById(id: string) {
        const res = await apiFetch(`${this.APIUrl}/${id}`, {
            method: 'GET'
        });
        return Promise.resolve(res);
    }

    // create a new work task or update its data
    public static createOrUpdate(task: WorkTask) {
        
        return apiFetch(`${this.APIUrl}`, {
            method: 'POST',
            body: JSON.stringify(task)
        }).then(res => {
            return Promise.resolve(res);
        });
    }

    // Delete Work task by id
    public static async deleteById(id: number | undefined) {
        const res = await apiFetch(`${this.APIUrl}/${id}`, {
            method: 'DELETE'
        });
        return Promise.resolve(res);
    }


}